import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ReferralLinkBanner = () => {
  const { referCode } = useParams();
  const [fallbackUrl, setFallbackUrl] = useState("");

  useEffect(() => {
    if (!referCode) {
      return;
    }

    const fullPackageName = "com.feedants";
    const scheme = "feedants";
    const appLink = `${scheme}://referral/${referCode}`;

    // Play Store (app link with referral)
    const playStoreLink = `https://play.google.com/store/apps/details?id=${fullPackageName}&referrer=referral%3D${referCode}`;
    const marketLink = `market://details?id=${fullPackageName}&referrer=referral%3D${referCode}`; // opens Play Store app

    // App Store (no custom referral params allowed by Apple)
    const iosStoreLink = "https://apps.apple.com/in/app/feedants/id6477408585";

    // Detect device
    const ua = window.navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = ua.includes("Android");
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isAndroid) {
      // Prefer "intent://" for deep link with fallback to Play Store app
      const intentUrl = `intent://${appLink.split("://")[1]}#Intent;scheme=${scheme};package=${fullPackageName};S.browser_fallback_url=${encodeURIComponent(
        marketLink
      )};S.market_referrer=referral%3D${referCode};end`;
      setFallbackUrl(intentUrl);
      window.location.href = intentUrl;
    } else if (isIOS) {
      // iOS can’t use intent:// → try deeplink, then fallback App Store
      setFallbackUrl(iosStoreLink);

      // Try opening app first
      window.location.href = appLink;

      // If fails → redirect to App Store after 2s
      setTimeout(() => {
        // window.location.href = iosStoreLink;
        document.getElementById("fallback-link")?.classList.remove("hidden");
      }, 2000);
    } else {
      // Desktop fallback → just show Play Store page
      setFallbackUrl(playStoreLink);
      window.location.href = playStoreLink;
    }
  }, [referCode]);

  return (
    <div style={{ padding: 20, textAlign: "center", backgroundColor: "white" }}>
      {referCode ? (
        <>
          <p>
            Redirecting with referral code: <strong>{referCode}</strong>…
          </p>
          <a
            id="fallback-link"
            href={fallbackUrl}
            className="hidden"
            style={{
              display: "inline-block",
              marginTop: 10,
              padding: "10px 20px",
              background: "#008080",
              color: "white",
              borderRadius: "6px",
              textDecoration: "none",
              fontWeight: "600",
            }}
          >
            Click here if nothing happens
          </a>
        </>
      ) : (
        <p>No referral code detected.</p>
      )}
    </div>
  );
};

export default ReferralLinkBanner;